import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IAuthUserListItem } from './types';

export const useGetAuthUsersList = () => {
  const { responseHandler } = useResponseHandler();

  return useQuery<IAuthUserListItem[], DefaultError>({
    queryKey: ['admin-auth-users-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Auth/UsersList',
      });

      return responseHandler(response, {
        groupName: 'useGetAuthUsersList',
      });
    },
  });
};
